import { DonneesInitiales } from '../../../modele/donnee-parcours/donneesInitiales/donneesInitiales';
import { DonneesParcours } from '../../../modele/donnee-parcours/donnees-parcours';
import { TypePromotion } from '../../../modele/promotion/type-promotion.enum';
import { VersementInteretContrat } from '../contrat/versement-interet-contrat';

export class VersementInteretModel {
  constructor(public readonly donneesParcours: DonneesParcours) {}

  obtenirContrat(): VersementInteretContrat {
    const { transaction } = this.donneesParcours;
    const produitSelectionne = this.obtenirProduitSelectionne();
    const estPreCELI = this.estPreCELI();
    const typeRachat = produitSelectionne.typeRachat;

    return {
      regime: transaction.regime,
      produitSelectionne,
      estPreCELI,
      typeRachat
    };
  }

  private obtenirProduitSelectionne() {
    const { donneesInitiales, transaction } = this.donneesParcours;
    return new DonneesInitiales(donneesInitiales).obtenirProduitParId(transaction.regime, transaction.idProduit);
  }

  public estPreCELI() {
    const produitSelectionne = this.obtenirProduitSelectionne();
    return produitSelectionne?.promotion?.typePromotion === TypePromotion.PRECELI;
  }
}
